import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { isEmpty } from 'lodash';
import { IUser } from '../../../typings/timetracker/timetracker';
import { TimesheetService } from '../../pages/timesheets/providers/timesheet.service';
import { EmployeeAutoCompleteService } from '../../providers/employee-auto-complete';
import { UserService } from '../../providers/user.service';


/**
 * Generated class for the UserWeekSelectorComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'user-selector',
  templateUrl: 'user-selector.html'
})
export class UserSelectorComponent implements OnInit {

  private _selectedUser: IUser;

  /**
   * Get selected user
   */
  public get selectedUser(): IUser {
    return this._selectedUser;
  }

  /**
   * Set the selected user
   */
  public set selectedUser( user: IUser ) {
    this.userChange.emit( user );
    this._selectedUser = user;
    if ( window && window.localStorage ) {
      if ( user ) {
          console.log( '[USER-SELECTOR] Storing user in local storage', user.id );
          window.localStorage.setItem( this.$timesheetService.USER_STORAGE_LABEL, `${user.id}` );
      }
    }
  }

  @Output() userChange: EventEmitter<IUser> = new EventEmitter();

  /**
   * Wire the arrow keys to this component
   * @param {KeyboardEvent} event The input event
   */
  @HostListener('window:keyup', ['$event'] )
  keyEvent( event: KeyboardEvent ): void {

    const notInputTarget = event.target[ 'type' ] === undefined || event.target[ 'type' ] !== 'number';

    if ( event.keyCode === 38 && notInputTarget ) { // Up arrow key
      this.selectedUser && this.previousUser( this.selectedUser );
    }

    if ( event.keyCode === 40 && notInputTarget ) { // Down arrow key
      this.selectedUser && this.nextUser( this.selectedUser );
    }
  }

  /**
   * @param {IUser} user The user to select
   */
  public selectUser( user: IUser ): void {
    this.selectedUser = user;
  }

  /**
   * @param {IUser} user Select the previous user based on this user
   */
  public previousUser( user: IUser ) {
    if ( user ) {
      this.$userService.selectPreviousUserByIdFetch( user.id ).take( 1 ).subscribe( user => {
        console.log( '[USER-SELECTOR] previous user', user );
        this.selectedUser = user;
      } );
    }
  }

  /**
   * @param {IUser} user Select the next user based on this user
   */
  public nextUser( user: IUser ) {
    if ( user ) {
      this.$userService.selectNextUserByIdFetch( user.id ).take( 1 ).subscribe( user => {
        console.log( '[USER-SELECTOR] next user', user );
        this.selectedUser = user;
      } );
    }
  }

  ngOnInit() {

    const localStorageData = this.$timesheetService.getStoredTimesheetData();

    if ( localStorageData.userId )
    {
      this.$userService.selectUserByIdFetch( localStorageData.userId )
        .filter(  user => !isEmpty( user ) )
        .take( 1 )
        .do( user => console.log( '[USER-SELECTOR] Select user from local storage', user ) )
        .subscribe( user =>
        {
          this.selectedUser = user;
        } );
    } else
    {
      this.$userService.selectUserFetchAll()
      .filter(  user => !isEmpty( user ) )
      .take( 1 )
      .do( user => console.log( '[USER-SELECTOR] Select first user as current user', user ) )
      .subscribe( response =>
      {
          if ( response && response.items.length ) {
            this.selectedUser = response.items[ 0 ];
          }
      } );
    }
  }

  constructor(
    public employeeAutoCompleteService: EmployeeAutoCompleteService,
    public $timesheetService: TimesheetService,
    private $userService: UserService,
  ) {}
}



// WEBPACK FOOTER //
// ./src/components/user-selector/user-selector.ts